import { IconButton, styled } from '@mui/material'

export const LinksList = styled('ul')`
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: center;
  padding-top: 32px;
  padding-bottom: 32px;
`

export const LinkButtonSt = styled(IconButton as any)`
  width: 35px;
  height: 35px;

  border: 1px solid ${({ theme }) => theme.palette.secondary.main};
  border-radius: 50%;
`
